import React, {useRef} from "react";
import {css, useTheme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {elevation} from "@pg-design/elevation";
import {BrandWeightIcon, CheckIcon, ListAddIcon} from "@pg-design/icons-module";

import {useFavourites} from "../../favorite/hooks/use_favourites";
import {hitGtmAddToCompareClick} from "../../favorite/tracking/favourite_gtm_events";
import {gtmFavouriteAddToFavouritesClick} from "../../favorite/tracking/gtm_event_favourites_multilead";
import {handleFavouritesListCheckHit} from "../../tracking/algolytics_hits/favourites_list_hit";

interface IProps {
    offerId: number;
    propertyId?: number;
    size?: string;
    wrapperSize?: string;
    withText?: boolean;
    className?: string;
}

export const FavouriteIcon = (props: IProps) => {
    const {size = "2.6", wrapperSize = "4", propertyId, offerId} = props;
    const theme = useTheme();
    const iconRef = useRef<HTMLDivElement | null>(null);
    const {
        isOfferInFavourites,
        isPropertyInFavourites,
        addPropertyToFavourites,
        addOfferToFavourites,
        removePropertyFromFavourites,
        removeOfferFromFavourites
    } = useFavourites();

    const isInFavourites = propertyId ? isPropertyInFavourites(propertyId) : isOfferInFavourites(offerId);

    const onFavouriteToggle = async () => {
        const {offerId, propertyId} = props;

        if (propertyId && isInFavourites) {
            await removePropertyFromFavourites(propertyId);

            hitGtmAddToCompareClick(false);
            handleFavouritesListCheckHit(false, offerId, propertyId);
        } else if (!propertyId && isInFavourites) {
            await removeOfferFromFavourites(offerId);

            gtmFavouriteAddToFavouritesClick(false);
            handleFavouritesListCheckHit(false, offerId);
        } else if (propertyId && !isInFavourites) {
            await addPropertyToFavourites(propertyId, offerId);

            hitGtmAddToCompareClick(true);
            handleFavouritesListCheckHit(true, offerId, propertyId);
        } else {
            //  !propertyId && !isInFavourites
            await addOfferToFavourites(offerId);

            gtmFavouriteAddToFavouritesClick(true);
            handleFavouritesListCheckHit(true, offerId);
        }
    };

    const handleClick = (e: React.MouseEvent) => {
        if (!props.withText) {
            e.stopPropagation();
        }

        e.preventDefault();
        onFavouriteToggle();
    };

    const renderIcon = (): React.ReactNode => {
        if (isInFavourites) {
            return <CheckIcon size={size} wrapperSize={wrapperSize} wrapperColor={theme.colors.primary} css={elevation(1)} />;
        } else if (!isInFavourites && propertyId) {
            return <BrandWeightIcon size={size} wrapperSize={wrapperSize} wrapperColor="#fff" css={elevation(1)} />;
        } else {
            return <ListAddIcon size={size} wrapperSize={wrapperSize} wrapperColor="#fff" css={elevation(1)} />;
        }
    };

    const renderWithText = (): React.ReactNode => {
        return (
            // TODO: the appearance of this button should be consulted with UX/UI specialist
            // It is currently not used in app
            <Button variant="none_secondary" iconLeft={ListAddIcon}>
                <span>Dodaj do listy ulubionych</span>
            </Button>
        );
    };

    return (
        <div css={favouriteIconBaseStyle} data-id={`favouriteIcon-${props.offerId}`} onClick={handleClick} ref={iconRef} className={props.className}>
            {props.withText ? renderWithText() : renderIcon()}
        </div>
    );
};

//  Styles
const favouriteIconBaseStyle = css`
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
`;
import React, {useRef} from "react";
import {css, useTheme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {elevation} from "@pg-design/elevation";
import {BrandWeightIcon, CheckIcon, ListAddIcon} from "@pg-design/icons-module";

import {useFavourites} from "../../favorite/hooks/use_favourites";
import {hitGtmAddToCompareClick} from "../../favorite/tracking/favourite_gtm_events";
import {gtmFavouriteAddToFavouritesClick} from "../../favorite/tracking/gtm_event_favourites_multilead";
import {handleFavouritesListCheckHit} from "../../tracking/algolytics_hits/favourites_list_hit";

interface IProps {
    offerId: number;
    propertyId?: number;
    size?: string;
    wrapperSize?: string;
    withText?: boolean;
    className?: string;
}

export const FavouriteIcon = (props: IProps) => {
    const {size = "2.6", wrapperSize = "4", propertyId, offerId} = props;
    const theme = useTheme();
    const iconRef = useRef<HTMLDivElement | null>(null);
    const {
        isOfferInFavourites,
        isPropertyInFavourites,
        addPropertyToFavourites,
        addOfferToFavourites,
        removePropertyFromFavourites,
        removeOfferFromFavourites
    } = useFavourites();

    const isInFavourites = propertyId ? isPropertyInFavourites(propertyId) : isOfferInFavourites(offerId);

    const onFavouriteToggle = async () => {
        const {offerId, propertyId} = props;

        if (propertyId && isInFavourites) {
            await removePropertyFromFavourites(propertyId);

            hitGtmAddToCompareClick(false);
            handleFavouritesListCheckHit(false, offerId, propertyId);
        } else if (!propertyId && isInFavourites) {
            await removeOfferFromFavourites(offerId);

            gtmFavouriteAddToFavouritesClick(false);
            handleFavouritesListCheckHit(false, offerId);
        } else if (propertyId && !isInFavourites) {
            await addPropertyToFavourites(propertyId, offerId);

            hitGtmAddToCompareClick(true);
            handleFavouritesListCheckHit(true, offerId, propertyId);
        } else {
            //  !propertyId && !isInFavourites
            await addOfferToFavourites(offerId);

            gtmFavouriteAddToFavouritesClick(true);
            handleFavouritesListCheckHit(true, offerId);
        }
    };

    const handleClick = (e: React.MouseEvent) => {
        if (!props.withText) {
            e.stopPropagation();
        }

        e.preventDefault();
        onFavouriteToggle();
    };

    const renderIcon = (): React.ReactNode => {
        if (isInFavourites) {
            return <CheckIcon size={size} wrapperSize={wrapperSize} wrapperColor={theme.colors.primary} css={elevation(1)} />;
        } else if (!isInFavourites && propertyId) {
            return <BrandWeightIcon size={size} wrapperSize={wrapperSize} wrapperColor="#fff" css={elevation(1)} />;
        } else {
            return <ListAddIcon size={size} wrapperSize={wrapperSize} wrapperColor="#fff" css={elevation(1)} />;
        }
    };

    const renderWithText = (): React.ReactNode => {
        return (
            // TODO: the appearance of this button should be consulted with UX/UI specialist
            // It is currently not used in app
            <Button variant="none_secondary" iconLeft={ListAddIcon}>
                <span>Dodaj do listy ulubionych</span>
            </Button>
        );
    };

    return (
        <div css={favouriteIconBaseStyle} data-id={`favouriteIcon-${props.offerId}`} onClick={handleClick} ref={iconRef} className={props.className}>
            {props.withText ? renderWithText() : renderIcon()}
        </div>
    );
};

//  Styles
const favouriteIconBaseStyle = css`
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
`;
